import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./Admin/login/login.component";
import { CreateUserComponent } from "./Admin/create-user/create-user.component";
import { UserListComponent } from "./Admin/user-list/user-list.component";
import { ScreenShotViwerComponent } from "./Admin/screen-shot-viwer/screen-shot-viwer.component";
import { ProjectsComponent } from "./Admin/projects/projects.component";
import { AddProjectComponent } from "./Admin/projects/add-project/add-project.component";
import { TabsComponent } from "./Admin/tabs/tabs.component";

import { LoginGuard } from "./utils/login.guard";
import { DashboardComponent } from "./Admin/dashboard/dashboard.component";
import { FormGuard, UserSettingPanelComponent } from "./Admin/user-setting-panel/user-setting-panel.component";
import { EmployeeEditComponent } from "./Admin/employee-edit/employee-edit.component";
import { SignupComponent } from "./signup/signup.component"
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { NewPasswordComponent } from './new-password/new-password.component';
import { VerificationCodeComponent } from './verification-code/verification-code.component';
import { ResetSucessfullyComponent } from './reset-sucessfully/reset-sucessfully.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { settingGuardGuard } from "./user-setting-panel/setting-guard.guard";
import { UserProfileComponent } from "./Admin/user-profile/user-profile.component";
import { UserProfileInfoComponent } from "./user-profile-info/user-profile-info/user-profile-info.component";
import { UserPlansComponent } from "./user-plans/user-plans/user-plans.component";
import { PlanExpiredComponent } from "./QuotaBanner/plan-expired/plan-expired.component";
import { planExpiredGuardGuard } from "./utils/plan-expired-guard.guard";
import { checkTokenGuard } from "./utils/check-token.guard";
import { UserReportComponent } from "./Admin/user-list/user-report/user-report.component";
import { PrivacyPolicyComponent } from "./policy-pages/privacy-policy/privacy-policy.component";
import { RefundPolicyComponent } from "./policy-pages/refund-policy/refund-policy.component";
import { ShippingExchangePolicyComponent } from "./policy-pages/shipping-exchange-policy/shipping-exchange-policy.component";
import { TermsConditionComponent } from "./policy-pages/terms-condition/terms-condition.component";
import { AboutUsComponent } from "./about-us/about-us.component";
import { MagicLinkAuthComponent } from "./magic-link-auth/magic-link-auth.component";
import { MagicLinkGuard } from "./utils/magic-link.guard";
import { ScreenshotsComponent } from "./Admin/screenshots/screenshots.component";
import { WorkReplayComponent } from "./Admin/work-replay/work-replay.component";
import { onBoardingGuard } from "./utils/on-boarding.guard";
import { OnboardingChecklistComponent } from "./onboarding-checklist/onboarding-checklist.component";
import { ExampleWorkdayComponent } from "./example-workday/example-workday.component";
import { setupGuard } from "./utils/setup.guard";
import { AdminGuard } from "./utils/admin.guard";
import { AuditLogsComponent } from "./Admin/audit-logs/audit-logs.component";
import { LiveMonitoringComponent } from "./live-monitoring/live-monitoring.component";
import { EntitlementGuard, ENTITLEMENT_ROUTE_DATA } from "./utils/entitlement.guard";
import { FeatureLockedComponent } from "./entitlements/feature-locked/feature-locked.component";
import { OnBoardingComponent } from "./on-boarding/on-boarding.component";
import { DemoConsoleComponent } from "./demo-console/demo-console.component";
import { ConductTimelogsComponent } from "./Admin/conduct-timelogs/conduct-timelogs.component";



const routes: Routes = [
  {
    path: "",
    component: DashboardComponent,
    canActivate: [MagicLinkGuard, LoginGuard, onBoardingGuard, planExpiredGuardGuard],
    title: "Supersee",
  },
  {
    path: "signup",
    component: SignupComponent,
    canActivate: [checkTokenGuard],
    title: "Start your free trial · SuperSee",
  },
  {
    path: "verification-code",
    component: VerificationCodeComponent,
    canActivate: [checkTokenGuard],
    title: "Supersee",
  },
  {
    path: "welcome",
    component: WelcomeComponent,
    canActivate: [LoginGuard, planExpiredGuardGuard],
    title: "Supersee",
  },
  {
    path: "reset-sucessfully",
    component: ResetSucessfullyComponent,
    canActivate: [checkTokenGuard],
    title: "Supersee",
  },
  {
    path: "new-password",
    component: NewPasswordComponent,
    canActivate: [checkTokenGuard],
    title: "Supersee",
  },
  {
    path: "forgot-password",
    component: ForgotPasswordComponent,
    canActivate: [checkTokenGuard],
    title: "Supersee",
  },
  {
    path: "dashboard",
    component: DashboardComponent,
    canActivate: [LoginGuard, onBoardingGuard, planExpiredGuardGuard],
    title: "Supersee",
  },
  {
    path: "screenshots",
    component: ScreenshotsComponent,
    canActivate: [LoginGuard, onBoardingGuard, planExpiredGuardGuard],
    title: "Screenshots - Supersee",
  },
  {
    path: "work-replay",
    component: WorkReplayComponent,
    canActivate: [LoginGuard, onBoardingGuard, planExpiredGuardGuard, EntitlementGuard],
    data: ENTITLEMENT_ROUTE_DATA.workReplay,
    title: "Work Replay - Supersee",
  },
  {
    path: "conduct-timelogs",
    component: ConductTimelogsComponent,
    canActivate: [LoginGuard, onBoardingGuard, planExpiredGuardGuard],
    title: "Conduct Timelogs - Supersee",
  },
  {
    path: "login",
    component: LoginComponent,
    canActivate: [checkTokenGuard],
    title: "Log in · SuperSee",
  },

  {
    path: "auth",
    component: MagicLinkAuthComponent,
    title: "Authentication - Supersee",
  },
  {
    path: "employees",
    component: UserListComponent,
    canActivate: [LoginGuard, onBoardingGuard],
    title: "Supersee",
  },
  {
    path: "privacy-policy",
    component: PrivacyPolicyComponent,
    title: "Privacy Policy - Supersee",
  },
  {
    path: "refund-policy",
    component: RefundPolicyComponent,
    title: "Refund Policy - Supersee",
  },
  {
    path: "shipping-exchange-policy",
    component: ShippingExchangePolicyComponent,
    title: "Shipping & Exchange Policy - Supersee",
  },
  {
    path: "terms-conditions",
    component: TermsConditionComponent,
    title: "Terms & Conditions - Supersee",
  },
  {
    path: "about-us",
    component: AboutUsComponent,
    title: "About Us - Supersee",
  },
  {
    path: "teams",
    component: ProjectsComponent,
    canActivate: [LoginGuard, onBoardingGuard, planExpiredGuardGuard],
    title: "Supersee",
  },
  {
    path: "user-details/:userId",
    component: TabsComponent,
    canActivate: [LoginGuard, onBoardingGuard, planExpiredGuardGuard],
    title: "Supersee",
  },
  {
    path: "projects/add-project",
    component: AddProjectComponent,
    canActivate: [LoginGuard, onBoardingGuard, planExpiredGuardGuard],
    title: "Supersee",
  },
  {
    path: "projects",
    component: ProjectsComponent,
    canActivate: [LoginGuard, onBoardingGuard, planExpiredGuardGuard],
    title: "Supersee",
  },
  {
    path: "help-support",
    loadChildren: () => import("../app/Admin/help-and-support/help-and-support.module").then(m => m.HelpAndSupportModule),
    canActivate: [LoginGuard, onBoardingGuard, planExpiredGuardGuard],
  },
  {
    path: "employee/setting",
    component: UserSettingPanelComponent,
    canActivate: [LoginGuard && settingGuardGuard, onBoardingGuard, planExpiredGuardGuard],
    canDeactivate: [FormGuard],
    title: "Supersee",
  },
  {
    path: "employee/setting/:userId",
    component: UserSettingPanelComponent,
    canActivate: [LoginGuard, onBoardingGuard, planExpiredGuardGuard],
    title: "Supersee",
  },
  {
    path: "employee-profile/edit",
    component: EmployeeEditComponent,
    canActivate: [LoginGuard, onBoardingGuard, planExpiredGuardGuard],
    title: "Supersee",
  },
  {
    path: "user-profile-info",
    component: UserProfileInfoComponent,
    canActivate: [LoginGuard, onBoardingGuard, planExpiredGuardGuard],
    title: "Supersee",
  },
  {
    path: "plan-expired",
    component: PlanExpiredComponent,
    canActivate: [LoginGuard, onBoardingGuard],
    title: "Supersee",
  },
  {
    path: "billings",
    component: UserPlansComponent,
    canActivate: [LoginGuard, onBoardingGuard],
    title: "Supersee",
  },
  {
    path: "user-plans",
    redirectTo: "billings",
    pathMatch: "full",
  },
  {
    path: "billing-invoices",
    loadChildren: () => import("./billing-invoices/billing-invoices.module").then(m => m.BillingInvoicesModule),
    canActivate: [LoginGuard, onBoardingGuard, AdminGuard],
    title: "Billing & Invoices - Supersee",
  },
  {
    path: "user-report",
    component: UserReportComponent,
    canActivate: [LoginGuard, onBoardingGuard, planExpiredGuardGuard],
    title: "Supersee",
  },
  {
    path: "user-report/:userId",
    component: UserReportComponent,
    canActivate: [LoginGuard, onBoardingGuard, planExpiredGuardGuard],
    title: "Supersee",
  },
  {
    path: 'reports',
    loadChildren: () => import('./Admin/reports/reports.module').then(m => m.ReportsModule),
    canActivate: [LoginGuard, onBoardingGuard, planExpiredGuardGuard, EntitlementGuard],
    data: ENTITLEMENT_ROUTE_DATA.websiteUsage,
    title: 'Supersee Reports',
  },
  {
    path: 'productivity-trends',
    loadChildren: () =>
      import('./Admin/productivity-trends/productivity-trends.module').then(m => m.ProductivityTrendsModule),
    canActivate: [LoginGuard, onBoardingGuard, planExpiredGuardGuard, EntitlementGuard],
    data: ENTITLEMENT_ROUTE_DATA.productivityTrends,
    title: 'Productivity Trends - Supersee',
  },
  {
    path: 'feature-locked',
    component: FeatureLockedComponent,
    canActivate: [LoginGuard, planExpiredGuardGuard],
    title: 'Feature locked - Supersee',
  },
  {
    path: "setup",
    component: OnboardingChecklistComponent,
    canActivate: [LoginGuard, setupGuard],
    title: "Setup Wizard - Supersee",
  },
  {
    path: "setup/example-workday",
    component: ExampleWorkdayComponent,
    canActivate: [LoginGuard, setupGuard],
    title: "Example workday - Supersee",
    data: { data_source: "scoped_example" },
  },
  {
    path: "setup/:step",
    component: OnboardingChecklistComponent,
    canActivate: [LoginGuard, setupGuard],
    title: "Setup Wizard - Supersee",
  },
  {
    path: "data-management",
    loadChildren: () => import("../app/Admin/data-management/data-management.module").then(m => m.DataManagementModule),
    canActivate: [LoginGuard, onBoardingGuard, planExpiredGuardGuard, AdminGuard, EntitlementGuard],
    data: ENTITLEMENT_ROUTE_DATA.dataManagement,
  },
  {
    path: "audit-logs",
    component: AuditLogsComponent,
    canActivate: [LoginGuard, onBoardingGuard, planExpiredGuardGuard, AdminGuard, EntitlementGuard],
    data: ENTITLEMENT_ROUTE_DATA.auditLogs,
    title: "Audit Logs - Supersee",
  },
  {
    path: "live-monitoring",
    component: LiveMonitoringComponent,
    canActivate: [LoginGuard, onBoardingGuard, planExpiredGuardGuard, EntitlementGuard],
    data: ENTITLEMENT_ROUTE_DATA.liveMonitoring,
    title: "Live Monitoring - Supersee",
  },
  {
    path: "device-management",
    loadChildren: () => import("./Admin/device-management/device-management.module").then(m => m.DeviceManagementModule),
    canActivate: [LoginGuard, onBoardingGuard, planExpiredGuardGuard, AdminGuard, EntitlementGuard],
    data: ENTITLEMENT_ROUTE_DATA.deviceManagement,
    title: "Devices - Supersee",
  },
  {
    path: "onboarding",
    redirectTo: "/setup/ready",
    pathMatch: "full",
  },
  {
    path: "demo-console",
    component: DemoConsoleComponent,
    canActivate: [LoginGuard, planExpiredGuardGuard],
    title: "Demo Console - Supersee",
  },
  {
    path: "**",
    redirectTo: "/dashboard",
    pathMatch: "full"
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
